import React from 'react';
import { processSteps } from '../mockData';
import { CheckCircle, ArrowRight } from 'lucide-react';

const Process = () => {
  return (
    <section className="py-32 bg-gradient-to-b from-white via-emerald-50 to-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Elegant Section Header - Centered */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center space-x-2 bg-white border-2 border-emerald-200 rounded-full px-6 py-2 mb-6 shadow-md">
            <div className="w-2 h-2 bg-emerald-600 rounded-full animate-pulse"></div>
            <span className="text-emerald-700 font-bold text-sm uppercase tracking-wider">Simple Process</span>
          </div>
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-6">
            How It
            <span className="block bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">Works</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Get started in minutes with our streamlined onboarding process
          </p>
        </div>

        {/* Elegant Horizontal Flow Layout */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-16">
          {processSteps.map((step, index) => (
            <div key={step.step} className="relative">
              {/* Elegant Step Card */}
              <div className="group bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border-2 border-emerald-100 hover:border-emerald-300 h-full">
                {/* Step Number Badge */}
                <div className="relative mb-6">
                  <div className="absolute inset-0 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-2xl blur-lg opacity-30"></div>
                  <div className="relative w-16 h-16 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-2xl flex items-center justify-center shadow-lg">
                    <span className="text-white font-black text-3xl">{step.step}</span>
                  </div>
                </div>

                <h3 className="text-2xl font-black text-gray-900 mb-4 group-hover:text-emerald-600 transition-colors">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed mb-6">
                  {step.description}
                </p>
                
                {/* Benefits Badge */}
                <div className="inline-flex items-center space-x-2 bg-emerald-50 rounded-full px-4 py-2">
                  <CheckCircle size={16} className="text-emerald-600" />
                  <span className="text-emerald-600 font-bold text-sm">Fast Setup</span>
                </div>
              </div>

              {/* Connector Arrow (except last) */}
              {index < processSteps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <ArrowRight size={32} className="text-emerald-300" />
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center">
          <p className="text-2xl text-gray-900 mb-6 font-bold">Ready to get started?</p>
          <a
            href="/contact"
            className="inline-flex items-center space-x-2 bg-gradient-to-r from-emerald-600 to-teal-600 text-white px-10 py-5 rounded-full font-bold text-lg shadow-xl hover:shadow-2xl transition-all duration-300"
          >
            <span>Start Your Journey Now</span>
            <ArrowRight size={24} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Process;